@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <ix-checkbox
      [formControl]="control"
      [label]="attribute.translation.label | translate"
      class="cb-padding"
      id="{{ attribute.name }}"
    ></ix-checkbox>
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
